<template>
    <div class="toggle-line">
        <div class="on-of-button" :class="{ active: active }" @click="changeStatus()">
            <div class="circle">
                <Icon iconName="check" width="16" height="16" viewBox="0 0 16 16" />
            </div>
        </div>
        {{ label }}
    </div>
</template>
<script>
export default {
    name: "OnOffButton",
    props: {
        label: {
            typeof: String,
            default: ''
        },
        active: {
            typeof: Boolean,
            default: false
        },
    },
    model: {
        prop: 'active',
        event: 'changed'
    },
    methods: {
        changeStatus() {
            let newStatus = !this.active
            this.$emit('changed', newStatus)
            this.$set(this, 'active', newStatus)
        }
    }
}
</script>
<style lang="scss">
.toggle-line {
    display: flex;
    align-items: center;
    width: 100%;

    .on-of-button {
        background: #767676;
        border-radius: 16px;
        width: 44px;
        height: 24px;
        position: relative;
        display: flex;
        align-items: center;

        transition: all .3s;
        padding: 3px 4px;
        cursor: pointer;
        margin-right: 16px;

        &.active {
            background: #457323;

            svg {
                opacity: 1;
            }

            .circle {
                left: calc(100% - 18px);
            }
        }

        .circle {
            width: 18px;
            min-width: 18px;
            max-width: 18px;
            height: 18px;
            min-height: 18px;
            max-height: 18px;
            background: #fff;
            border-radius: 50%;
            color: #457323;
            transition: all .3s;
            display: flex;
            align-items: center;
            justify-content: center;
            position: relative;
            left: 0%;
        }

        svg {
            transition: all .3s;
            opacity: 0;
        }
    }
}
</style>